import React from 'react';
import { Navigate } from 'react-router-dom';

const PartnerLogin = () => <Navigate to="/login?mode=partner" replace />;

export default PartnerLogin;
